import { IRoleEnum } from "@interfaces";
import { createRoute } from "@routes/utils";

import { supplierListRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";

const permission = [IRoleEnum.STORE];

const supplierListRouteMetadata: IRouteMetadataObj<
  typeof supplierListRoutesObj
> = {
  list: {
    title: "basicInfo.index.title",
    description: "empty",
    lazy: () => import("@pages/basicInfo/supplier/table/page"),
    mode: "index",
    type: "main",
    icon: "Information2Line",
    breadcrumbs: [],
    permission,
  },
  create: {
    title: "basicInfo.supplierManagement.create.title",
    description: "empty",
    lazy: () => import("@/pages/basicInfo/supplier/form/page"),
    mode: "create",
    type: "inner",
    icon: "AddLine",
    breadcrumbs: [],
    permission,
  },
  edit: {
    title: "basicInfo.supplierManagement.edit.title",
    description: "empty",
    lazy: () => import("@/pages/basicInfo/supplier/form/page"),
    mode: "edit",
    type: "inner",
    icon: "EditLine",
    breadcrumbs: [],
    permission,
  },
};

export const supplierListRoutes = createRoute<typeof supplierListRoutesObj>(
  supplierListRoutesObj,
  supplierListRouteMetadata,
);
